import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Projects', path: '/projects' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const isHome = location.pathname === '/';

  return (
    <>
      <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''} ${!isHome ? 'navbar--inner' : ''} ${menuOpen ? 'navbar--open' : ''} ${!scrolled && isHome ? 'navbar--transparent-home' : ''}`}>
        <div className="navbar__inner">
          {/* Logo */}
          <Link to="/" className="navbar__logo">
            <img
              src="/logo-icon.png"
              alt="PrimeFix icon"
              className={`navbar__logo-icon-img ${!scrolled && isHome ? 'navbar__logo-icon-img--light' : ''}`}
            />
            <div className="navbar__logo-wordmark">
              <div className="navbar__logo-brand">
                <span className="navbar__logo-prime">PRIME</span><span className="navbar__logo-fix">FIX</span>
              </div>
              <div className="navbar__logo-sub">— SOLUTIONS LIMITED —</div>
              <div className="navbar__logo-tagline">RELIABLE SOLUTIONS. EXCEPTIONAL SERVICE.</div>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="navbar__nav">
            {navLinks.map(({ label, path }) => (
              <Link
                key={path}
                to={path}
                className={`navbar__link ${location.pathname === path ? 'navbar__link--active' : ''}`}
              >
                {label}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <Link to="/contact" className="navbar__cta btn btn-primary">
            Get a Quote
          </Link>

          {/* Hamburger */}
          <button
            className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      {/* Mobile Overlay */}
      <div
        className={`navbar__overlay ${menuOpen ? 'navbar__overlay--visible' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Mobile Menu (Side Drawer) */}
      <div className={`navbar__mobile ${menuOpen ? 'navbar__mobile--open' : ''}`}>
        <div className="navbar__mobile-header">
          <div className="navbar__logo">
            <img
              src="/logo-icon.png"
              alt="PrimeFix icon"
              className="navbar__logo-icon-img"
            />
            <div className="navbar__logo-wordmark">
              <div className="navbar__logo-brand">
                <span className="navbar__logo-prime">PRIME</span><span className="navbar__logo-fix">FIX</span>
              </div>
              <div className="navbar__logo-sub">— SOLUTIONS LIMITED —</div>
              <div className="navbar__logo-tagline">RELIABLE SOLUTIONS. EXCEPTIONAL SERVICE.</div>
            </div>
          </div>
          <button
            className="navbar__mobile-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2.5" fill="none">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <nav className="navbar__mobile-nav">
          {navLinks.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              className={`navbar__mobile-link ${location.pathname === path ? 'navbar__mobile-link--active' : ''}`}
            >
              {label}
            </Link>
          ))}
          <div className="navbar__mobile-footer">
            <Link to="/contact" className="btn btn-primary navbar__mobile-cta">
              Get a Quote &rarr;
            </Link>
          </div>
        </nav>
      </div>
    </>
  );
}

